import { Heading, type HeadingProps } from "@tokenterminal/core/ui/heading/Heading"
import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"

const MarketingHeading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ level, className, ...props }, ref) => {
    return (
      <Heading
        level={level}
        className={twMerge("tracking-tighter", className)}
        ref={ref}
        {...props}
      />
    )
  },
)

MarketingHeading.displayName = "MarketingHeading"

export default MarketingHeading
